import { render } from "./VerifyLayout.vue?vue&type=template&id=5958170a"
import script from "./VerifyLayout.vue?vue&type=script&lang=js"
export * from "./VerifyLayout.vue?vue&type=script&lang=js"

import "./VerifyLayout.vue?vue&type=style&index=0&id=5958170a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__